// libraries.
import { FetchBaseQueryError } from "@reduxjs/toolkit/query";

// slices.
import { apiBudgetRoute } from "../apiSlices";

// interfaces.
import { ModelError } from "../interfaces/interfaces";
import {
  RawRule,
  RawRuleItem,
  RulesSchema,
} from "./interfaces/rawRules.interfaces";

// ─── Request / Response types ─────────────────────────────────────────────────

export interface UpdateRuleBody {
  rule_id: string;
  schema: RulesSchema;
  rule: RawRule;
  is_active?: "active" | "inactive";
  changed_by?: string;
}

interface UpdateRuleApiResponse {
  success: boolean;
  data: RawRuleItem;
  message: string;
}

// ─── Endpoint ─────────────────────────────────────────────────────────────────

export const editRulesEndpoints = apiBudgetRoute.injectEndpoints({
  endpoints: (builder) => ({
    updateRule: builder.mutation<RawRuleItem, UpdateRuleBody>({
      query: (body) => ({
        url: "/rules",
        method: "PUT",
        body,
      }),
      invalidatesTags: (_result, _error, body) => [{ type: "Rules", id: body.schema }],
      transformErrorResponse: (error: FetchBaseQueryError) => {
        const modelError: ModelError = {
          errorStatus: error.status,
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          messageFromServer: (error.data as any)?.message,
          serviceErrorName: "updateRule",
        };
        return modelError;
      },
      transformResponse: (raw: UpdateRuleApiResponse) => raw.data,
    }),
  }),
});

export const { useUpdateRuleMutation } = editRulesEndpoints;
